var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 9,
    viewBox: "0 0 15 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49997 -2.57492e-05C7.23114 -2.57492e-05 6.96235 0.102619 6.75739 0.307479L0.307713 6.75722C-0.102571 7.1675 -0.102571 7.83271 0.307713 8.24283C0.71783 8.65294 1.3829 8.65294 1.79322 8.24283L7.49997 2.53574L13.2068 8.24263C13.617 8.65275 14.2821 8.65275 14.6921 8.24263C15.1026 7.83251 15.1026 7.16731 14.6921 6.75702L8.24256 0.30728C8.0375 0.102386 7.76871 -2.57492e-05 7.49997 -2.57492e-05Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.d1437e1f0d1b6a2b9a80622716ebd5b6.svg";
export { ForwardRef as ReactComponent };